import { PageHeader } from "@/shared/ui/PageHeader";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { EcommerceStatsRow } from "./components/EcommerceStatsRow";
import { RevenueChart } from "./components/RevenueChart";
import { TopProducts } from "./components/TopProducts";
import { SalesByCategory } from "./components/SalesByCategory";
import { RecentOrders } from "./components/RecentOrders";

export function EcommerceDashboard() {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <PageHeader title={t.ecommerce.pageTitle} description={t.ecommerce.pageDescription} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 md:gap-5">
        <EcommerceStatsRow />
        <RevenueChart />
        <SalesByCategory />
        <TopProducts />
        <RecentOrders />
      </div>
    </div>
  );
}
